












































import { DashboardService, ListaAtendimento } from "@/services/dashboard.service";
import Vue from "vue";
import Component from "vue-class-component";
import { Watch, Prop } from "vue-property-decorator";
import { dateFormatterSemHoras } from "@/shared/filters";

@Component({ 
  filters: { dateFormatterSemHoras }
})
export default class AtendimentosDoDiaTable extends Vue {
  listaAtendimentosDia: ListaAtendimento[] | null = null;
  loadingAtendimentosDia = false;

  @Prop() readonly date!: string | null;

  mounted() {
    this.onChangeDate();
  }

  @Watch("date")
  onChangeDate() {
    this.ListaAtendimentosDiaTV();
  }

  async ListaAtendimentosDiaTV() {
    this.loadingAtendimentosDia = true;
    if (this.date) {
      this.listaAtendimentosDia = await DashboardService.ListaAtendimento(this.date).finally(
        () => (this.loadingAtendimentosDia = false)
      );
    }
  }

  get limitedAtendimentosDia() {
    return this.listaAtendimentosDia?.slice(0, 14);
  }
}
